import { Component, computed, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AnalyseService } from '../../../services/analyse-service';
import { ToastrService } from 'ngx-toastr';
import { FamilyAnalyseData } from '../../../models/FamilyAnalyseData';
import { AttendingStatus } from '../../../models/AttendingStatus.enum';
import { InvitationType } from '../../../models/InvitationType.enum';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-dashboard',
  imports: [BaseChartDirective],
  templateUrl: './dashboard.html',
  styleUrl: 'dashboard.scss',
})
export class Dashboard implements OnInit {

  private analyseService = inject(AnalyseService);
  private toastrService = inject(ToastrService);
  showLoader = signal(false);

  notRespondedFamilies: WritableSignal<FamilyAnalyseData[]> = signal([]);
  acceptedFamilies: WritableSignal<FamilyAnalyseData[]> = signal([]);
  refusedFamilies: WritableSignal<FamilyAnalyseData[]> = signal([]);
  notSureFamilies: WritableSignal<FamilyAnalyseData[]> = signal([]);

  numberOfAcceptedPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.persons.length
      );
      return c;
    }
  );
  numberOfRefusedPersons = computed(
    () => {
      let c = 0;
      this.refusedFamilies().forEach(
        family => c += family.persons.length
      );
      return c;
    }
  );
  numberOfWaitingPersons = computed(
    () => {
      let c = 0;
      this.notRespondedFamilies().forEach(
        family => c += family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length
      );
      return c;
    }
  );
  numberOfNotSurePersons = computed(
    () => {
      let c = 0;
      this.notSureFamilies().forEach(
        family => c += family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length
      );
      return c;
    }
  );
  numberOfTotalAcceptedVHPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH.getKey() || family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfTotalAcceptedMealPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType !== InvitationType.VH.getKey() && family.invitationType !== InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedFriendsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedFamilyPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.FAMILLE.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedParentsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS_PARENTS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedVHParentsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedVHPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      return c;
    }
  );
  numberOfInvitedFriendsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS.getKey() ? family.persons.length : 0
      );
      this.refusedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS.getKey() ? family.persons.length : 0
      );
      this.notSureFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      this.notRespondedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      return c;
    }
  );
  numberOfInvitedFamilyPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.FAMILLE.getKey() ? family.persons.length : 0
      );
      this.refusedFamilies().forEach(
        family => c += family.invitationType === InvitationType.FAMILLE.getKey() ? family.persons.length : 0
      );
      this.notSureFamilies().forEach(
        family => c += family.invitationType === InvitationType.FAMILLE.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      this.notRespondedFamilies().forEach(
        family => c += family.invitationType === InvitationType.FAMILLE.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      return c;
    }
  );
  numberOfInvitedParentsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS_PARENTS.getKey() ? family.persons.length : 0
      );
      this.refusedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS_PARENTS.getKey() ? family.persons.length : 0
      );
      this.notSureFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS_PARENTS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      this.notRespondedFamilies().forEach(
        family => c += family.invitationType === InvitationType.AMIS_PARENTS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      return c;
    }
  );
  numberOfInvitedVHParentsPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      this.refusedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length : 0
      );
      this.notSureFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      this.notRespondedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH_PARENTS.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      return c;
    }
  );
  numberOfInvitedVHPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH.getKey() ? family.persons.length : 0
      );
      this.refusedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH.getKey() ? family.persons.length : 0
      );
      this.notSureFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      this.notRespondedFamilies().forEach(
        family => c += family.invitationType === InvitationType.VH.getKey() ? family.persons.length === 1 && family.canRequireCoupleInvite ? 2 : family.persons.length : 0
      );
      return c;
    }
  );
  numberOfAcceptedChildrens = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.persons.filter(
          person => !person.adult
        ).length
      );
      return c;
    }
  );
  numberOfTotalAcceptedBrunchPersons = computed(
    () => {
      let c = 0;
      this.acceptedFamilies().forEach(
        family => c += family.staysForBrunch ? family.persons.length : 0
      );
      return c;
    }
  );

  responseDoughnutData = computed(
    () => {
      return {
        labels: [AttendingStatus.ATTENDING.getValue(), AttendingStatus.NOT_ATTENDING.getValue(), AttendingStatus.NOT_RESPONDED.getValue(), AttendingStatus.NOT_SURE_YET.getValue()],
        datasets: [{
          label: ' ',
          data: [
            { id: AttendingStatus.ATTENDING.getKey(), value: this.numberOfAcceptedPersons() },
            { id: AttendingStatus.NOT_ATTENDING.getKey(), value: this.numberOfRefusedPersons() },
            { id: AttendingStatus.NOT_RESPONDED.getKey(), value: this.numberOfWaitingPersons() },
            { id: AttendingStatus.NOT_SURE_YET.getKey(), value: this.numberOfNotSurePersons() }
          ],
          backgroundColor: [
            "#198754", "#dc3545", "#ffc107", "#0d6efd"
          ],
          hoverBorderColor: "#aaa",
          hoverBorderWidth: 3,
          hoverOffset: 20 
        }]
      }
    }
  );

  responseDoughnutOptions = computed(
    () => {
      return {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom" as "top" | "left" | "right" | "bottom" | "center",
          },
          title: {
            display: true,
            text: 'Nombre de personnes par réponse',
            position: "top" as "top" | "left" | "right" | "bottom"
          }
        }
      }
    }
  );

  invitationTypeAcceptedDoughnutData = computed(
    () => {
      return {
        labels: [
          InvitationType.AMIS.getValue(),
          InvitationType.FAMILLE.getValue(),
          InvitationType.AMIS_PARENTS.getValue(),
          InvitationType.VH.getValue(),
          InvitationType.VH_PARENTS.getValue(),
        ],
        datasets: [{
          label: ' ',
          data: [
            { id: InvitationType.AMIS.getKey(), value: this.numberOfAcceptedFriendsPersons() },
            { id: InvitationType.FAMILLE.getKey(), value: this.numberOfAcceptedFamilyPersons() },
            { id: InvitationType.AMIS_PARENTS.getKey(), value: this.numberOfAcceptedParentsPersons() },
            { id: InvitationType.VH.getKey(), value: this.numberOfAcceptedVHPersons() },
            { id: InvitationType.VH_PARENTS.getKey(), value: this.numberOfAcceptedVHParentsPersons() }
          ],
          backgroundColor: [
            "#fd7e14", "#d63384", "#a37651", "#6f42c1", "rgb(181, 161, 255)"
          ],
          hoverBorderColor: "#aaa",
          hoverBorderWidth: 3,
          hoverOffset: 20 
        }]
      }
    }
  );

  invitationTypeAcceptedDoughnutOptions = computed(
    () => {
      return {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom" as "top" | "left" | "right" | "bottom" | "center",
          },
          title: {
            display: true,
            text: 'Nombre de personnes par type d\'invitation ayant acceptés',
            position: "top" as "top" | "left" | "right" | "bottom"
          }
        }
      }
    }
  );

  invitationTypeInvitedDoughnutData = computed(
    () => {
      return {
        labels: [
          InvitationType.AMIS.getValue(),
          InvitationType.FAMILLE.getValue(),
          InvitationType.AMIS_PARENTS.getValue(),
          InvitationType.VH.getValue(),
          InvitationType.VH_PARENTS.getValue(),
        ],
        datasets: [{
          label: ' ',
          data: [
            { id: InvitationType.AMIS.getKey(), value: this.numberOfInvitedFriendsPersons() },
            { id: InvitationType.FAMILLE.getKey(), value: this.numberOfInvitedFamilyPersons() },
            { id: InvitationType.AMIS_PARENTS.getKey(), value: this.numberOfInvitedParentsPersons() },
            { id: InvitationType.VH.getKey(), value: this.numberOfInvitedVHPersons() },
            { id: InvitationType.VH_PARENTS.getKey(), value: this.numberOfInvitedVHParentsPersons() }
          ],
          backgroundColor: [
            "#fd7e14", "#d63384", "#a37651", "#6f42c1", "rgb(181, 161, 255)"
          ],
          hoverBorderColor: "#aaa",
          hoverBorderWidth: 3,
          hoverOffset: 20 
        }]
      }
    }
  );

  invitationTypeInvitedDoughnutOptions = computed(
    () => {
      return {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom" as "top" | "left" | "right" | "bottom" | "center",
          },
          title: {
            display: true,
            text: 'Nombre de personnes par type d\'invitation ayant acceptés',
            position: "top" as "top" | "left" | "right" | "bottom"
          }
        }
      }
    }
  );

  ngOnInit(): void {
    this.refreshDataSet();
  }

  refreshDataSet(): void {
    this.showLoader.set(true);
    this.analyseService.getCompleteFamiliesData().then(
      response => {
        this.notRespondedFamilies.set(response.completeData.filter(
          family => family.attendingStatus === AttendingStatus.NOT_RESPONDED.getKey()
        ));
        this.acceptedFamilies.set(response.completeData.filter(
          family => family.attendingStatus === AttendingStatus.ATTENDING.getKey()
        ));
        this.refusedFamilies.set(response.completeData.filter(
          family => family.attendingStatus === AttendingStatus.NOT_ATTENDING.getKey()
        ));
        this.notSureFamilies.set(response.completeData.filter(
          family => family.attendingStatus === AttendingStatus.NOT_SURE_YET.getKey()
        ));
      }
    ).catch(() => this.toastrService.error('Erreur de recuperation'))
      .finally(
        () => this.showLoader.set(false)
      );
  }

}
